import { XeroFetchedAccountDto } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { NotificationsStore } from "@stores/notifications/NotificationsStore.ts";

export const displayOptions = (
  fetchedAccount: XeroFetchedAccountDto[],
  filterFn: (x: XeroFetchedAccountDto) => boolean | undefined
) =>
  fetchedAccount.filter(filterFn).map((x: XeroFetchedAccountDto) => ({
    key: x.id,
    text: x.name ?? ""
  }));

export async function executeAndNotify<Type>(
  operation: () => Promise<Type>,
  successMessage: string,
  notification: NotificationsStore
) {
  try {
    await operation();
    notification.success(successMessage);
  } catch (e) {
    notification.error(e.message);
  }
}
